import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { ProductDetail } from "./components/ProductDetail";
import { ProductsContainer } from "./components/products.container";

function ProductDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.products.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<PageLoading />}>
      <ProductDetail productId={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function ProductsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<ProductsContainer />} />
        <Route path=":id" element={<ProductDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
